import {
  query,
  where,
  getDocs,
  collection,
  DocumentData,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";

import { Utils } from "utils";
import { db, functions } from "configs";
import { IPlace, Iterable } from "types";
import { COLLECTIONS, FUNCTIONS } from "constants/firebase";

type InitRequest = { tag: string; countryCode: string };
type InitResoponse = { logDocumentsIds: string[] };

export const collect = (data: InitRequest) => {
  const callable = httpsCallable<InitRequest, InitResoponse>(
    functions,
    FUNCTIONS.INIT_COLLECT_PLACES
  );
  return callable(data);
};

export const checkRouteAvailability = async (data: {
  ids: string[];
  currentDate: string;
  graphhopperKeyID: string;
}) => {
  try {
    const { ids, ...props } = data;

    const callable = httpsCallable<
      { ids: string; graphhopperKeyID: string; currentDate: string },
      {}
    >(functions, FUNCTIONS.PLACE_AVAILABILITY_FOR_ROUTE, { timeout: 540000 });
    const response = await callable({
      ...props,
      ids: JSON.stringify(data.ids),
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const listByCountries = async (countryCodes: string[]) => {
  const chunks = Utils.Helpers.chunkArray(countryCodes, 10);

  const coll = collection(db, COLLECTIONS.Dump);
  let queries: ReturnType<typeof query<DocumentData>>[] = [];

  chunks.forEach((chunk) => {
    const q = query(coll, where("address_info.country_code", "in", chunk));
    queries.push(q);
  });

  const responses = await Promise.all(
    queries.map(async (q) => await getDocs(q))
  );
  const documents = responses.map((response) => {
    return Utils.Helpers.castDocs<Iterable<IPlace>>(response);
  });

  return documents.flat(1);
};
